import React from "react";
import { currentTheme, smetaStore } from "../../atoms";

// eslint-disable-next-line @typescript-eslint/naming-convention
function StyleSmetaComponents() {
  const theme = smetaStore.get(currentTheme);
  return (
    <style>{`
    :root {
    // --indicatorColor: #faf9f5;
    --accent-blue: rgb(98, 142, 184);
    --bg-blue:#f8f8f8;
    --accent-light:#faf9f5;
    --font-color-blue:#ffffff;
    --bg-light:#faf9f5;
    --selected-light:#dcd8cc;
    --font-color-light:#616161;
    --accordion-light: #dcd8cc;
    --header-light: #dcd8cc;
    --iconButtonColor: #ffffff;
    --iconButtonColor-light:#616161;
    --iconColorStimate: rgb(4, 4, 4);
    --iconColorStimate-light: rgb(179, 173, 151);
    --darker-light:#c6ba97;
}
.setfont
{
    font: 300 13px/19px 'Open Sans','Helvetica Neue',helvetica,arial,verdana,sans-serif;
    letter-spacing :0px;
}
.ellipsis
{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.hidden{
    display:none !important;
}

.date-range{
    background-color: rgba(25, 118, 210, 0.12);
    border-radius:0;
    margin:0;
    width:40px;
}

.date-range-light{
    background-color: #eeeeee;
    border-radius:0;
    margin:0;
    width:40px;
}

.date-range-start{
    background-color: #1976d2 !important;
    border-radius: 0;
    margin:0;
    width:40px;
}

.date-range-start-light{
    background-color: rgb(220, 216, 204) !important;
    border-radius: 0;
    margin:0;
    width:40px;
}
${
  theme === "light"
    ? `
    .Mui-selected{
    color: #000000 !important;
    background-color: rgb(220, 216, 204) !important;
    font-weight: 500;
    }
    `
    : `
    .Mui-selected{
    color: #fff;
    background-color: #1976d2;
    font-weight: 500;
    }
    `
}

.date-range-end{
    background-color: #1976d2 !important;
    border-radius: 0;
    margin:0;
    width:40px;
}
.date-range-end-light{
    background-color: rgb(220, 216, 204) !important;
    border-radius: 0;
    margin:0;
    width:40px;
}

.date-range-current{
    outline: 1px solid;
    }

input[type=date]::-webkit-calendar-picker-indicator {
    background-image: url("data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjYgMjYiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+DQogIDxwYXRoIGQ9Ik03IDBDNi40NDkyMTkgMCA2IDAuNDQ5MjE5IDYgMUw2IDRDNiA0LjU1MDc4MSA2LjQ0OTIxOSA1IDcgNUM3LjU1MDc4MSA1IDggNC41NTA3ODEgOCA0TDggMUM4IDAuNDQ5MjE5IDcuNTUwNzgxIDAgNyAwIFogTSAxOSAwQzE4LjQ0OTIxOSAwIDE4IDAuNDQ5MjE5IDE4IDFMMTggNEMxOCA0LjU1MDc4MSAxOC40NDkyMTkgNSAxOSA1QzE5LjU1MDc4MSA1IDIwIDQuNTUwNzgxIDIwIDRMMjAgMUMyMCAwLjQ0OTIxOSAxOS41NTA3ODEgMCAxOSAwIFogTSAzIDJDMS4zNDM3NSAyIDAgMy4zNDM3NSAwIDVMMCAyM0MwIDI0LjY1NjI1IDEuMzQzNzUgMjYgMyAyNkwyMyAyNkMyNC42NTYyNSAyNiAyNiAyNC42NTYyNSAyNiAyM0wyNiA1QzI2IDMuMzQzNzUgMjQuNjU2MjUgMiAyMyAyTDIxIDJMMjEgNEMyMSA1LjEwMTU2MyAyMC4xMDU0NjkgNiAxOSA2QzE3Ljg5NDUzMSA2IDE3IDUuMTAxNTYzIDE3IDRMMTcgMkw5IDJMOSA0QzkgNS4xMDE1NjMgOC4xMDU0NjkgNiA3IDZDNS44OTQ1MzEgNiA1IDUuMTAxNTYzIDUgNEw1IDIgWiBNIDIgOUwyNCA5TDI0IDIzQzI0IDIzLjU1MDc4MSAyMy41NTA3ODEgMjQgMjMgMjRMMyAyNEMyLjQ0OTIxOSAyNCAyIDIzLjU1MDc4MSAyIDIzIFogTSA0LjM0Mzc1IDExQzQuMTI4OTA2IDExLjA3MDMxMyAzLjk4ODI4MSAxMS4yNzM0MzggNCAxMS41TDQgMTQuMjE4NzVDMy44ODY3MTkgMTQuMzkwNjI1IDMuODg2NzE5IDE0LjYwOTM3NSA0IDE0Ljc4MTI1TDQgMTguMjgxMjVDMy45MzM1OTQgMTguNDE3OTY5IDMuOTMzNTk0IDE4LjU4MjAzMSA0IDE4LjcxODc1TDQgMjEuNUM0IDIxLjc3NzM0NCA0LjIyMjY1NiAyMiA0LjUgMjJMMjEuNSAyMkMyMS43NzczNDQgMjIgMjIgMjEuNzc3MzQ0IDIyIDIxLjVMMjIgMTguNjI1QzIyLjAxNTYyNSAxOC41NTQ2ODggMjIuMDE1NjI1IDE4LjQ3NjU2MyAyMiAxOC40MDYyNUwyMiAxNC42MjVDMjIuMDE1NjI1IDE0LjU1NDY4OCAyMi4wMTU2MjUgMTQuNDc2NTYzIDIyIDE0LjQwNjI1TDIyIDExLjVDMjIgMTEuMjIyNjU2IDIxLjc3NzM0NCAxMSAyMS41IDExTDQuNSAxMUM0LjQ2ODc1IDEwLjk5NjA5NCA0LjQzNzUgMTAuOTk2MDk0IDQuNDA2MjUgMTFDNC4zODY3MTkgMTEgNC4zNjMyODEgMTEgNC4zNDM3NSAxMSBaIE0gNSAxMkw4IDEyTDggMTMuMDkzNzVDNy41NjY0MDYgMTMuMjQyMTg4IDcuMjQyMTg4IDEzLjU2NjQwNiA3LjA5Mzc1IDE0TDUgMTQgWiBNIDkgMTJMMTMgMTJMMTMgMTNMOSAxMyBaIE0gMTQgMTJMMTcgMTJMMTcgMTRMMTQuOTA2MjUgMTRDMTQuNzU3ODEzIDEzLjU2NjQwNiAxNC40MzM1OTQgMTMuMjQyMTg4IDE0IDEzLjA5Mzc1IFogTSAxOCAxMkwyMSAxMkwyMSAxNEwxOCAxNCBaIE0gNSAxNUw3IDE1TDcgMThMNSAxOCBaIE0gOSAxNUwxMyAxNUwxMyAxOEw5IDE4IFogTSAxNSAxNUwxNyAxNUwxNyAxOEwxNSAxOCBaIE0gMTggMTVMMjEgMTVMMjEgMThMMTggMTggWiBNIDUgMTlMNy4wOTM3NSAxOUM3LjI0MjE4OCAxOS40MzM1OTQgNy41NjY0MDYgMTkuNzU3ODEzIDggMTkuOTA2MjVMOCAyMUw1IDIxIFogTSAxNC45MDYyNSAxOUwxNyAxOUwxNyAyMUwxNCAyMUwxNCAxOS45MDYyNUMxNC40MzM1OTQgMTkuNzU3ODEzIDE0Ljc1NzgxMyAxOS40MzM1OTQgMTQuOTA2MjUgMTkgWiBNIDE4IDE5TDIxIDE5TDIxIDIxTDE4IDIxIFogTSA5IDIwTDEzIDIwTDEzIDIxTDkgMjFaIiAvPg0KPC9zdmc+");
}
    `}</style>
  );
}

export { StyleSmetaComponents };
